/**
 * `GET /api/branding/by-hostname` — the branding-bootstrap read (SASATH-0305). Not
 * bearer-protected, not CSRF-protected (`isBearerPath` / `isCsrfProtectedPath` in
 * `./client` already exclude it; `client.test.ts` pins the bearer exclusion).
 *
 * Types only the field this unit consumes — the endpoint returns a full branding
 * payload, but modelling fields nothing reads is speculative surface.
 */
import { apiClient, unwrap } from './client';
import type { ApiResponse } from './types';

export interface BrandingByHostname {
  /** Full centralized-login URL paired to this host's domain; null when the tenant has no LOGIN host. */
  loginUrl: string | null;
}

export const brandingApi = {
  async byHostname(host: string): Promise<BrandingByHostname> {
    const { data } = await apiClient.get<ApiResponse<BrandingByHostname>>(
      `/api/branding/by-hostname?host=${encodeURIComponent(host)}`,
    );
    return unwrap(data);
  },
};
